var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContentItem(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "47.000000pt",
    height: "44.000000pt",
    viewBox: "0 0 47.000000 44.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,44.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120 340 c-17 -17 -20 -33 -20 -120 0 -134 6 -140 130 -140 124 0 130 6 130 140 0 134 -6 140 -130 140 -77 0 -93 -3 -110 -20z m210 -19 c13 -25 13 -177 0 -202 -9 -17 -22 -19 -100 -19 -108 0 -110 2 -110 120 0 118 2 120 110 120 78 0 91 -2 100 -19z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250 306 c0 -31 22 -48 57 -44 28 4 24 8 -22 23 -8 2 -15 14 -15 25 0 11 -4 20 -10 20 -5 0 -10 -11 -10 -24z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170 210 c0 -5 16 -10 35 -10 19 0 35 5 35 10 0 6 -16 10 -35 10 -19 0 -35 -4 -35 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170 150 c0 -6 27 -10 60 -10 33 0 60 4 60 10 0 6 -27 10 -60 10 -33 0 -60 -4 -60 -10z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentItem);
export default __webpack_public_path__ + "static/media/contentItem.81109068a28bd5923a3934201578af5d.svg";
export { ForwardRef as ReactComponent };